import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AccountDTO, TripDTO } from '../../interfaces/models';
import { LoadingService } from '../../providers/loading/loading.service';
import { TripService } from '../../providers/trip/trip.service';
import { UserService } from '../../providers/user/user.service';
import { NgSelectCompatModule } from '../../compat/ng-select/ng-select.module';
import { DirectivesModule } from '../../directives.module';
import { DriverDetailsRecordModule } from '../driver-details-record/driver-details-record.module';

interface DialogData {
  orderId: number;
  tripId: number;
}

@Component({
  selector: 'app-add-trip',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatDialogModule,
    NgSelectCompatModule,
    DirectivesModule,
    DriverDetailsRecordModule,
  ],
  templateUrl: './add-trip.component.html',
  styleUrls: ['./add-trip.component.scss'],
})
export class AddTripComponent implements OnInit {
  trips: TripDTO[] = [];
  limit = 10;
  skip = 0;
  count = 0;
  public dataForm = this.buildDataForm();

  constructor(
    private fb: FormBuilder,
    private tripService: TripService,
    private loadingService: LoadingService,
    private userService: UserService,
    public dialogRef: MatDialogRef<AddTripComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) { }

  ngOnInit() {
    this.getTrips();
    this.dataForm.controls.orderId.setValue(this.data.orderId);
    this.dataForm.controls.tripId.setValue(this.data.tripId);
  }

  public addToTrip() {
    this.loadingService.startLoading();
    const { orderId, tripId } = this.dataForm.getRawValue();
    this.tripService.assignOrder(tripId as number, orderId as number)
      .subscribe((res) => {
        this.dialogRef.close(res);
        this.loadingService.stopLoading();
      });
  }

  private getTrips() {
    this.tripService.getList({
      limit: this.limit,
      offset: this.skip,
      status: 'actives',
    })
      .subscribe((res) => {
        const trips = res.data.map(trip =>
          ({ ...trip, disabled: this.isDriverUnavailable(trip.driver) }));
        this.trips = [...this.trips, ...trips];
        this.count = res.count;
      });
  }

  public getListTrips() {
    if (this.trips.length < this.count) {
      this.skip = this.skip + this.limit;
      this.getTrips();
    }
  }

  public getTripDriver(trip: TripDTO) {
    const firstName = trip.driver && trip.driver.firstName || '';
    const lastName = trip.driver && trip.driver.lastName || '';
    if (!firstName || !lastName) {
      return trip.id;
    }

    return `${trip.id} - ${firstName} ${lastName}`;
  }

  private isDriverUnavailable(driver: AccountDTO) {
    return this.userService.isDriverUnavailable(driver);
  }

  private buildDataForm() {
    return this.fb.group({
      tripId: new FormControl<number | null>(null, [Validators.required]),
      orderId: new FormControl<number | null>(null, [Validators.required]),
    });
  }
}
